export default "__VITE_ASSET__BgCUv5qY__"